"use client";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import FilterSidebar from './FilterSidebar';
import ProductGrid from './ProductGrid';
import Header from '../Header';
import Footer from '../Footer';


const MenuPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredProducts, setFilteredProducts] = useState([]);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const products = [
    // {
    //   id: "ferrero-rocher-cake",
    //   name: "Ferrero Rocher cake",
    //   price: "$ 55",
    //   category: "Birthday cakes",
    //   priceRange: "50-75",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/25dcaf6a2bf081582c9ef5c5a481ffd59d2a1873?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "gulab-jamun",
    //   name: "Gulab Jamun",
    //   price: "$ 55",
    //   category: "Birthday cakes",
    //   priceRange: "50-75",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/4adb096bd76cefc696df83fe65ddd2e55807617f?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "rasmalai-cake",
    //   name: "Rasmalai cake",
    //   price: "$ 55",
    //   category: "Birthday cakes",
    //   priceRange: "50-75",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/0521e172f0a2ff8b9552c54495399396f65a81bf?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "butterscotch-cake",
    //   name: "Butterscotch cake",
    //   price: "$ 55",
    //   category: "Birthday cakes",
    //   priceRange: "50-75",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/42b5056d7ceb59ab306ef48c2c5547e8dd9469a1?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "blueberry-cake",
    //   name: "Blueberry cake",
    //   price: "$ 50",
    //   category: "Birthday cakes",
    //   priceRange: "25-50",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/ad852224650ff8582f0129007c0faac403cbf3cc?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "strawberry-cake",
    //   name: "Strawberry cake",
    //   price: "$ 50",
    //   category: "Birthday cakes",
    //   priceRange: "25-50",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/5220aa1f7794af2c7fd6e9a2477a6b497815aa0b?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "royal-wedding-cake",
    //   name: "Royal Wedding Cake",
    //   price: "$ 150",
    //   category: "Wedding cakes",
    //   priceRange: "100-200",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/25dcaf6a2bf081582c9ef5c5a481ffd59d2a1873?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "elegant-rose-cake",
    //   name: "Elegant Rose Cake",
    //   price: "$ 120",
    //   category: "Wedding cakes",
    //   priceRange: "100-200",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/4adb096bd76cefc696df83fe65ddd2e55807617f?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "superhero-theme",
    //   name: "Superhero Theme",
    //   price: "$ 80",
    //   category: "Custom cakes",
    //   priceRange: "75-100",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/ad852224650ff8582f0129007c0faac403cbf3cc?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },
    // {
    //   id: "princess-castle",
    //   name: "Princess Castle",
    //   price: "$ 90",
    //   category: "Custom cakes",
    //   priceRange: "75-100",
    //   image: "https://api.builder.io/api/v1/image/assets/TEMP/5220aa1f7794af2c7fd6e9a2477a6b497815aa0b?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    // },

    {
      id: "irani-chai",
      name: "Irani Chai",
      price: "$1.99",
      category: "Tea & Snacks",
      priceRange: "0-25", 
      image: "https://cdn.acsdev.in/iynacakes/iranichai.jpg"
    },
    {
      id: "osmania-biscuits",
      name: "Osmania Biscuits",
      price: "$2.89",
      category: "Tea & Snacks",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/OsmaniaBiscuits.jpg"
    },
    {
      id: "maska-bun",
      name: "Maska Bun",
      price: "$2.99",
      category: "Tea & Snacks",
      priceRange: "0-25", 
      image: "https://cdn.acsdev.in/iynacakes/MaskaBun.jpg"
    },
    {
      id: "chocolate-milkshake",
      name: "Chocolate Milkshake",
      price: "$5.99",
      category: "Milkshakes",
      priceRange: "0-25", 
      image: "https://cdn.acsdev.in/iynacakes/chocolatem.jpg"
    },
    {
      id: "strawberry-milkshake",
      name: "Strawberry Milkshake",
      price: "$6.99",
      category: "Milkshakes",
      priceRange: "0-25", 
      image: "https://cdn.acsdev.in/iynacakes/strawberry milkshake.jpg"
    },
    {
      id: "oreo-milkshake",
      name: "Oreo Milkshake",
      price: "$5.99",
      category: "Milkshakes",
      priceRange: "0-25", 
      image: "https://cdn.acsdev.in/iynacakes/oreo milkshake.jpg"
    },
    {
      id: "kit-kat-milkshake",
      name: "Kit Kat Milkshake",
      price: "$6.99",
      category: "Milkshakes",
      priceRange: "0-25", 
      image: "https://cdn.acsdev.in/iynacakes/kitkat.jpg"
    },
    {
      id: "rocher-milkshake",
      name: "Rocher Milkshake",
      price: "$6.99",
      category: "Milkshakes",
      priceRange: "0-25", 
      image: "https://cdn.acsdev.in/iynacakes/rocherm.jpg"
    },
    {
      id: "egg-puff",
      name: "Egg Puff",
      price: "$3.49",
      category: "Puffs",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Egg Puff.jpg"
    },
    {
      id: "chicken-puff",
      name: "Chicken Puff",
      price: "$4.49",
      category: "Puffs",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Chicken Puff.jpg"
    },
    {
      id: "veg-puff",
      name: "Veg Puff",
      price: "$3.49",
      category: "Puffs",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Veg Puff.jpg"
    },
    {
      id: "pineapple-cake",
      name: "Pineapple",
      price: "$50",
      category: "Cakes (1 KG)",
      priceRange: "25-50",
      image: "https://cdn.acsdev.in/iynacakes/Pineapple.jpg"
    },
    {
      id: "mango-cake",
      name: "Mango",
      price: "$50",
      category: "Cakes (1 KG)",
      priceRange: "25-50",
      image: "https://cdn.acsdev.in/iynacakes/Mango.jpg"
    },
    {
      id: "strawberry-cake-1kg",
      name: "Strawberry",
      price: "$50",
      category: "Cakes (1 KG)",
      priceRange: "25-50",
      image: "https://cdn.acsdev.in/iynacakes/Strawberry.jpg"
    },
    {
      id: "blueberry-cake-1kg",
      name: "Blueberry",
      price: "$50",
      category: "Cakes (1 KG)",
      priceRange: "25-50",
      image: "https://cdn.acsdev.in/iynacakes/Blueberry.jpg"
    },
    {
      id: "butterscotch-cake-1kg",
      name: "Butterscotch",
      price: "$52",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Butterscotch.jpg"
    },
    {
      id: "rasmalai-cake-1kg",
      name: "Rasmalai",
      price: "$55",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Rasmalai.jpg"
    },
    {
      id: "gulab-jamun-cake-1kg",
      name: "Gulab Jamun",
      price: "$55",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Gulab Jamun.jpg"
    },
    {
      id: "badham-almond-cake",
      name: "Badham (Almond)",
      price: "$55",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Badham (Almond).jpg"
    },
    {
      id: "pistachio-cake",
      name: "Pistachio",
      price: "$58",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Pistachio.jpg"
    },
    {
      id: "black-forest-cake",
      name: "Black Forest",
      price: "$58",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Black Forest.jpg"
    },
    {
      id: "tuffle-chocolate-cake",
      name: "Tuffle Chocolate",
      price: "$55",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Tuffle Chocolate.jpg"
    },
    {
      id: "rich-chocolate-cake",
      name: "Rich Chocolate",
      price: "$58",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Rich Chocolate.jpg"
    },
    {
      id: "ferrero-rocher-cake-1kg",
      name: "Ferrero Rocher",
      price: "$55",
      category: "Cakes (1 KG)",
      priceRange: "50-75",
      image: "https://cdn.acsdev.in/iynacakes/Ferrero Rocher.jpg"
    },
    {
      id: "pineapple-pastry",
      name: "Pineapple Pastry",
      price: "$5.99",
      category: "Pastries",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Pineapplep.jpg"
    },
    {
      id: "mango-pastry",
      name: "Mango Pastry",
      price: "$5.99",
      category: "Pastries",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Mangop.jpg"
    },
    {
      id: "strawberry-pastry",
      name: "Strawberry Pastry",
      price: "$5.99",
      category: "Pastries",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Strawberryp.jpg"
    },
    {
      id: "blueberry-pastry",
      name: "Blueberry Pastry",
      price: "$5.99",
      category: "Pastries",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Blueberryp.jpg"
    },
    {
      id: "butterscotch-pastry",
      name: "Butterscotch Pastry",
      price: "$5.99",
      category: "Pastries",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Butterscotchp.jpg"
    },
    {
      id: "chocolate-pastry",
      name: "Chocolate Pastry",
      price: "$5.99",
      category: "Pastries",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Chocolatep.jpg"
    },
    {
      id: "doll-cake",
      name: "Doll Cake",
      price: "",
      category: "Special Cakes",
      priceRange: "0-25", 
      image: "https://cdn.acsdev.in/iynacakes/Doll Cake.jpg"
    },
    {
      id: "pinata-cake",
      name: "Pinata Cake",
      price: "",
      category: "Special Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Pinata Cake.jpg"
    },
    {
      id: "mickey-mouse-cake",
      name: "Mickey Mouse Cake",
      price: "",
      category: "Special Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Mickey Mouse Cake.jpg"
    },
    {
      id: "teddy-bear-cake",
      name: "Teddy Bear Cake",
      price: "",
      category: "Special Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Teddy Bear Cake.jpg"
    },
    {
      id: "cake-in-bomb-shell",
      name: "Cake in Bomb Shell",
      price: "",
      category: "Special Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Cake in Bomb Shell.jpg"
    },
    {
      id: "rasmalai-jar-cake",
      name: "Rasmalai Jar Cake",
      price: "$5.99",
      category: "Jar Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Rasamalaijar.jpg"
    },
    {
      id: "badham-jar-cake",
      name: "Badham Jar Cake",
      price: "$5.99",
      category: "Jar Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Badhamjar.jpg"
    },
    {
      id: "pista-jar-cake",
      name: "Pista Jar Cake",
      price: "$5.99",
      category: "Jar Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Pistajar.jpg"
    },
    {
      id: "rich-chocolate-jar-cake",
      name: "Rich Chocolate Jar Cake",
      price: "$6.99",
      category: "Jar Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Rich Choclate jar.jpg"
    },
    {
      id: "pistachio-turrata-jar-cake",
      name: "Pistachio Turrata Jar Cake",
      price: "$7.99",
      category: "Jar Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Pistachio Turrata jar.jpg"
    },
    {
      id: "plain-brownie",
      name: "Plain Brownie",
      price: "$4.99",
      category: "Brownies",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Plain Brownie.jpg"
    },
    {
      id: "brownie-with-chocolate",
      name: "Brownie with Chocolate",
      price: "$5.99",
      category: "Brownies",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Brownie with Chocolate.jpg"
    },
    {
      id: "brownie-with-ice-cream",
      name: "Brownie with Ice Cream",
      price: "$6.99",
      category: "Brownies",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Brownie with Ice Cream.jpg"
    },
    {
      id: "sizzling-brownie",
      name: "Sizzling Brownie",
      price: "$9.99",
      category: "Brownies",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Sizzling Brownie.jpg"
    },
    {
      id: "chocolate-bomb-brownie",
      name: "Chocolate Bomb Brownie",
      price: "$12.99",
      category: "Brownies",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Chocolate Bomb Brownie.jpg"
    },
    {
      id: "vanilla-tres-leches",
      name: "Vanilla Tres Leches",
      price: "$6.99",
      category: "Tres Leches",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Vanilla leches.jpg"
    },
    {
      id: "badham-tres-leches",
      name: "Badham Tres Leches",
      price: "$7.99",
      category: "Tres Leches",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Badham leches.jpg"
    },
    {
      id: "rasmalai-tres-leches",
      name: "Rasmalai Tres Leches",
      price: "$7.99",
      category: "Tres Leches",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Rasmalai leches.jpg"
    },
    {
      id: "pistachio-tres-leches",
      name: "Pistachio Tres Leches",
      price: "$7.99",
      category: "Tres Leches",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Pistachio leches.jpg"
    },
    {
      id: "Pani-puri(12)",
      name: "Pani puri(12)",
      price: "$7.99",
      category: "Chaat Time",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Panipuri.jpg"
    },
    {
      id: "Dahi Puri(12)",
      name: "Dahi Puri(12)",
      price: "$9.99",
      category: "Chaat Time",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Dahipuri.jpeg"
    },
    {
      id: "Masala-Puri(12)",
      name: "Masala Puri(12)",
      price: "$9.99",
      category: "Chaat Time",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/masala.jpeg"
    },
    {
      id: "Pani-puri-Unlimited",
      name: "Pani puri Unlimited",
      price: "$11.99",
      category: "Chaat Time",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/PanipuriUnlimited.jpg"
    },
    {
      id: "Samosa-chat",
      name: "Samosa chat",
      price: "$9.99",
      category: "Chaat Time",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/Samosachat.jpg"
    },
    {
      id: "Aloo-Chat",
      name: "Aloo Chat",
      price: "$7.99",
      category: "Chaat Time",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/aloochat.jpg"
    },{
      id: "Flower Cake",
      name: "Flower Cake",
      price: "Contact Store",
      category: "Custom Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/flower.jpeg"
    },{
      id: "Gender Cake",
      name: "Gender Cake",
      price: "Contact Store",
      category: "Custom Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/baby.jpeg"
    }
    ,{
      id: "Mickey Mouse Cake",
      name: "Mickey Mouse Cake",
      price: "Contact Store",
      category: "Custom Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/mickey.jpeg"
    },{
      id: "Dog Cake",
      name: "Dog Cake",
      price: "Contact Store",
      category: "Custom Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/dog.jpeg"
    },{
      id: "Jungle cake",
      name: "Jungle Cake",
      price: "Contact Store",
      category: "Custom Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/jungle.jpeg"
    },
    {
      id: "Classic Step Cake",
      name: "Classic Step Cake",
      price: "Contact Store ",
      category: "Wedding Cakes",
      image: "https://cdn.acsdev.in/iynacakes/step.jpeg"
    },{
      id: "Harry Potter",
      name: "Harry Potter",
      price: "Contact Store",
      category: "Custom Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/harrypoter.jpeg"
    },{
      id: "All Animal Cake",
      name: "All Animal Cake",
      price: "Contact Store",
      category: "Custom Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/bigjungle.jpeg"
    }
  ];


  const itemsPerPage = 6;

  useEffect(() => {
    // Initialize with all products
    setFilteredProducts(products);
  }, []);

  const handleFilterChange = (filters) => {
    let filtered = products;

    // Filter by category
    const selectedCategories = Object.keys(filters.categories).filter(key => filters.categories[key]);
    if (selectedCategories.length > 0) {
      filtered = filtered.filter(product => selectedCategories.includes(product.category));
    }

    // Filter by price range
    const selectedPriceRanges = Object.keys(filters.priceRange).filter(key => filters.priceRange[key]);
    if (selectedPriceRanges.length > 0) {
      filtered = filtered.filter(product => selectedPriceRanges.includes(product.priceRange));
    }

    setFilteredProducts(filtered);
    setCurrentPage(1); // Reset to first page when filters change
  };

  // Calculate total pages dynamically based on filtered products
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Get current page products
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentProducts = filteredProducts.slice(startIndex, startIndex + itemsPerPage);

  // Floating food elements data with emojis
  const floatingElements = [
    { emoji: '🧁', size: 'text-4xl', delay: 0 },
    { emoji: '🍰', size: 'text-5xl', delay: 1 },
    { emoji: '🍪', size: 'text-3xl', delay: 2 },
    { emoji: '🥧', size: 'text-4xl', delay: 3 },
    { emoji: '🍩', size: 'text-3xl', delay: 4 },
    { emoji: '🧁', size: 'text-4xl', delay: 5 },
    { emoji: '🍰', size: 'text-5xl', delay: 6 },
    { emoji: '🍪', size: 'text-3xl', delay: 7 },
  ];

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        {/* Gradient Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-rose-50 to-orange-100" />

        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23dc2626' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }} />
        </div>

        {/* Floating Food Emoji Elements */}
        {floatingElements.map((element, index) => (
          <motion.div
            key={`emoji-${index}`}
            className={`absolute ${element.size} opacity-20 pointer-events-none`}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -30, 0],
              x: [0, Math.random() * 20 - 10, 0],
              rotate: [0, Math.random() * 20 - 10, 0],
            }}
            transition={{
              duration: 6 + Math.random() * 4,
              repeat: Infinity,
              delay: element.delay,
              ease: "easeInOut",
            }}
          >
            {element.emoji}
          </motion.div>
        ))}

        {/* Large Background Cake Elements with Slow Movement */}
        <motion.div
          className="absolute opacity-8 pointer-events-none"
          style={{
            left: `${Math.random() * 60}%`,
            top: `${Math.random() * 60}%`,
          }}
          animate={{
            x: [0, 100, -50, 150, 0],
            y: [0, -80, 120, -40, 0],
            rotate: [0, 5, -3, 8, 0],
            scale: [1, 1.05, 0.95, 1.1, 1],
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <div className="w-64 h-64 bg-gradient-to-br from-orange-200 to-red-200 rounded-full flex items-center justify-center text-8xl opacity-30">
            🎂
          </div>
        </motion.div>

        <motion.div
          className="absolute opacity-8 pointer-events-none"
          style={{
            right: `${Math.random() * 60}%`,
            bottom: `${Math.random() * 60}%`,
          }}
          animate={{
            x: [0, -120, 80, -60, 0],
            y: [0, 90, -110, 70, 0],
            rotate: [0, -5, 7, -3, 0],
            scale: [1, 1.1, 0.9, 1.05, 1],
          }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 5,
          }}
        >
          <div className="w-48 h-48 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center text-6xl opacity-30">
            🧁
          </div>
        </motion.div>

        {/* Additional Floating Cookie Elements */}
        <motion.div
          className="absolute opacity-12 pointer-events-none"
          style={{
            left: `${Math.random() * 40}%`,
            top: `${Math.random() * 70 + 15}%`,
          }}
          animate={{
            x: [0, 60, -40, 80, 0],
            y: [0, -50, 70, -30, 0],
            rotate: [0, 15, -10, 20, 0],
          }}
          transition={{
            duration: 18,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 3,
          }}
        >
          <div className="w-32 h-32 bg-gradient-to-br from-yellow-200 to-orange-300 rounded-full flex items-center justify-center text-4xl">
            🍪
          </div>
        </motion.div>

        <motion.div
          className="absolute opacity-12 pointer-events-none"
          style={{
            right: `${Math.random() * 40}%`,
            top: `${Math.random() * 50 + 25}%`,
          }}
          animate={{
            x: [0, -70, 50, -90, 0],
            y: [0, 60, -80, 40, 0],
            rotate: [0, -12, 18, -8, 0],
          }}
          transition={{
            duration: 22,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 7,
          }}
        >
          <div className="w-28 h-28 bg-gradient-to-br from-pink-200 to-red-300 rounded-full flex items-center justify-center text-3xl">
            🥧
          </div>
        </motion.div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Header />

        {/* Hero Section for Menu */}
        <motion.section
          className="relative py-20 px-10 text-center"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="relative z-10">
            <motion.h1
              className="text-6xl md:text-7xl font-bold text-cyan-900 mb-6"
              style={{ fontFamily: "'Sansita Swashed', cursive" }}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Delicious Menu
            </motion.h1>
            <motion.p
              className="text-xl text-slate-600 max-w-2xl mx-auto mb-8"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Discover our handcrafted collection of cakes, desserts, and sweet treats made with love and the finest ingredients
            </motion.p>

            {/* Decorative Elements */}
            <div className="flex justify-center items-center gap-6 mb-8">
              <motion.div
                className="w-16 h-1 bg-gradient-to-r from-red-500 to-orange-500 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: 64 }}
                transition={{ duration: 0.8, delay: 0.6 }}
              />
              <motion.div
                className="text-3xl bg-emerald-200 rounded-full p-4 inline-flex items-center justify-center"
                animate={{ rotate: [0, 10, -10, 0] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              >
                🍰
              </motion.div>
              <motion.div
                className="w-16 h-1 bg-gradient-to-l from-red-500 to-orange-500 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: 64 }}
                transition={{ duration: 0.8, delay: 0.6 }}
              />
            </div>
          </div>
        </motion.section>

        <main className="flex gap-7 p-10 w-full min-h-screen max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4 relative">
          {/* Sidebar */}
          <div className="flex-shrink-0 w-[285px] max-xl:w-full relative z-10">
            <FilterSidebar onFilterChange={handleFilterChange} />
          </div>

          {/* Main Content */}
          <section className="flex flex-col flex-1 gap-5 min-w-0 relative z-10">
            <ProductGrid products={currentProducts} totalItemsCount={filteredProducts.length} />

            {/* Enhanced Pagination */}
            {filteredProducts.length > itemsPerPage && (
              <motion.nav
                className="flex gap-2.5 justify-center items-center max-sm:flex-wrap max-sm:gap-1.5 mt-8 bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-orange-200"
                aria-label="Pagination Navigation"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <motion.button
                  className="px-6 py-3 text-base font-bold text-cyan-900 cursor-pointer hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 rounded-xl max-sm:px-3 max-sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 hover:bg-red-50"
                  onClick={handlePrevious}
                  disabled={currentPage === 1}
                  aria-label="Go to previous page"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  ← Previous
                </motion.button>

                <div className="flex items-center gap-2.5 max-sm:gap-1.5 overflow-x-auto whitespace-nowrap no-scrollbar px-1">
                  {(() => {
                    const total = totalPages;
                    const windowSize =
                      typeof window !== "undefined" && window.innerWidth >= 768 ? 9 : 5; // 9 on md+, 5 on mobile
                    const half = Math.floor(windowSize / 2);

                    let start = Math.max(1, currentPage - half);
                    let end = Math.min(total, start + windowSize - 1);
                    if (end - start + 1 < windowSize) start = Math.max(1, end - windowSize + 1);

                    const seq = [];
                    if (start > 1) {
                      seq.push(1);
                      if (start > 2) seq.push("ellipsis-left");
                    }
                    for (let p = start; p <= end; p++) seq.push(p);
                    if (end < total) {
                      if (end < total - 1) seq.push("ellipsis-right");
                      seq.push(total);
                    }

                    return seq.map((p, i) =>
                      typeof p === "number" ? (
                        <motion.button
                          key={`p-${p}`}
                          className={`px-4 py-2 text-base font-semibold rounded-xl cursor-pointer max-sm:px-3 max-sm:text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 ${
                            currentPage === p
                              ? "bg-gradient-to-r from-red-500 to-orange-500 text-white shadow-lg"
                              : "text-cyan-900 hover:bg-orange-100 bg-white"
                          }`}
                          onClick={() => handlePageChange(p)}
                          aria-label={`Go to page ${p}`}
                          aria-current={currentPage === p ? "page" : undefined}
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                        >
                          {p}
                        </motion.button>
                      ) : (
                        <span key={`e-${i}`} className="px-2 text-slate-400 select-none">
                          …
                        </span>
                      )
                    );
                  })()}
                </div>


                <motion.button
                  className="px-6 py-3 text-base font-bold text-cyan-900 cursor-pointer hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 rounded-xl max-sm:px-3 max-sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 hover:bg-red-50"
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                  aria-label="Go to next page"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Next →
                </motion.button>
              </motion.nav>
            )}
          </section>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default MenuPage;
